import { render, staticRenderFns } from "./GuidelineBox.vue?vue&type=template&id=a13e3700&scoped=true&"
import script from "./GuidelineBox.vue?vue&type=script&lang=ts&"
export * from "./GuidelineBox.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineBox.vue?vue&type=style&index=0&id=a13e3700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13e3700",
  null
  
)

export default component.exports